import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              热播榜单
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              实时热度排行，发现大家都在看的好剧
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} - ${item.type}`}
                  title={`${item.title} ${item.type} ${item.year}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="200"
                  height="280"
                />
                <div className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center bg-background-50/90 rounded-br-lg">
                  <span className={`text-sm font-heading font-bold ${
                    item.rank <= 3 ? 'text-accent-500' : 'text-foreground-500'
                  }`}>
                    {item.rank}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="text-[11px] bg-black/70 text-foreground-300 px-1.5 py-0.5 rounded">
                    {item.rating}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-1">{item.title}</h3>
                <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.type}</span>
                  <span>·</span>
                  <span>{item.year}</span>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <span className="text-[11px] text-accent-500 font-medium">{item.hot}</span>
                  <span className="text-[11px]">
                    {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500"></i>}
                    {item.change === 'down' && <i className="ri-arrow-down-line text-accent-500"></i>}
                    {item.change === 'same' && <i className="ri-subtract-line text-foreground-500"></i>}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}